import React from 'react';
import PropTypes from 'prop-types';
/* eslint react/no-danger: 0 */
import { useLabels, useFlags } from 'wsm-common-data';

const FacetTitle = ({ facetTitle, isCollapsed, groupId }) => {
	const labels = useLabels();
	const flags = useFlags();
	const improvedLocationFacetsFlag =
		flags['ws-inv-facets-improved-location-facets'];
	const isGeoLocationEnabled = !!window.DDC?.InvData?.getGeoData();
	const isAccountId = groupId === 'accountId';

	const isImprovedLocationFacetsEnabled =
		improvedLocationFacetsFlag && isGeoLocationEnabled && isAccountId;

	const label = isImprovedLocationFacetsEnabled
		? labels.get('SHOP_BY_STORE')
		: facetTitle;

	const createMarkup = () => {
		return { __html: `${label}` };
	};
	const expandIcon = isCollapsed ? 'ddc-icon-expand' : 'ddc-icon-collapse';

	return (
		<span className="w-100 d-flex justify-content-between">
			<span
				className={
					isImprovedLocationFacetsEnabled
						? 'facet-list-group-label ddc-font-size-xsmall font-weight-normal text-decoration-none'
						: 'facet-list-group-label text-decoration-none'
				}
				dangerouslySetInnerHTML={createMarkup()}
			/>
			<i
				data-testid="expand-icon"
				className={`ddc-icon icon-style-collapse ${expandIcon}`}
				aria-hidden="true"
			/>
		</span>
	);
};

FacetTitle.propTypes = {
	facetTitle: PropTypes.string.isRequired,
	isCollapsed: PropTypes.bool.isRequired,
	groupId: PropTypes.string
};

export default FacetTitle;
